import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/** Confirmação em sheet: sobe da base no mobile e centraliza no desktop. */
export function ConfirmSheet({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancelar",
  destructive,
  pending,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  pending?: boolean;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="top-auto bottom-0 left-0 max-w-none translate-x-0 translate-y-0 gap-5 rounded-b-none rounded-t-sheet border-fx-line bg-fx-surface p-5 pb-[max(20px,env(safe-area-inset-bottom))] data-[state=open]:slide-in-from-bottom data-[state=open]:zoom-in-100 data-[state=closed]:zoom-out-100 sm:top-1/2 sm:bottom-auto sm:left-1/2 sm:max-w-md sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-hero sm:p-6"
      >
        <div className="flex flex-col gap-2">
          <DialogTitle className="fx-display text-[21px] leading-[22px] tracking-[-0.025em] text-fx-title">
            {title}
          </DialogTitle>
          <DialogDescription className="text-sm leading-5 text-fx-secondary">
            {description}
          </DialogDescription>
        </div>
        <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <Button variant="quiet" size="lg" onClick={() => onOpenChange(false)}>
            {cancelLabel}
          </Button>
          <Button
            size="lg"
            variant={destructive ? "destructive" : "default"}
            className={destructive ? "border border-fx-danger/50" : undefined}
            disabled={pending}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
